import { Link } from "react-router-dom";

export default function About() {
  return (
    <main style={page}>
      <h1 style={heading}>About GatherYou</h1>

      <p>
        GatherYou is a free community for sharing and discovering Punjabi fashion and
        embroidery designs: suits, jutti, phulkari, bridal work, neck and sleeve patterns,
        borders and more. It is built for people who love embroidery, whether you stitch, design,
        run a boutique or simply look for ideas for your next suit.
      </p>

      <h2 style={subheading}>What you can do here</h2>
      <ul style={list}>
        <li>Post your own designs with photos, a caption and hashtags, so others can find them.</li>
        <li>Share embroidery machine files (such as DST, PES and JEF) along with the design, and
          download files that other members have shared.</li>
        <li>Follow designers you like, and like, comment on and save designs into your own folders.</li>
        <li>Browse what is trending this week and this month, or search by hashtag, design or person.</li>
        <li>Credit the design that inspired yours when you post your own version of it.</li>
        <li>Share any design with family, friends or your tailor through WhatsApp and other apps.</li>
        <li>Use the site in English, Punjabi or Hindi.</li>
      </ul>

      <h2 style={subheading}>Respect for creators</h2>
      <p>
        Every design belongs to the person who made it. Members agree to post only work they have
        the right to share, and to ask before using someone else's design commercially. Anyone can
        report a design or an account from the menu next to a post, and copyright complaints are
        handled as described in our <Link to="/terms" style={link}>Terms of Service</Link>.
      </p>

      <h2 style={subheading}>A safe place to share</h2>
      <p>
        GatherYou is for adults: you must be at least 18 to create an account. Reports are
        reviewed, content that breaks the rules is removed, and you can block or mute anyone you do
        not want to see. Read how we handle your information in our{" "}
        <Link to="/privacy" style={link}>Privacy Policy</Link>.
      </p>

      <h2 style={subheading}>Get in touch</h2>
      <p>
        GatherYou is run from Punjab, India. For questions, feedback or complaints, write to{" "}
        <a href="mailto:contact@gatheryou.in" style={link}>contact@gatheryou.in</a>, or visit the{" "}
        <Link to="/help" style={link}>Help page</Link>.
      </p>

      <p>
        New here? Start with the <Link to="/trending" style={link}>trending designs</Link> or read our{" "}
        <a href="/guides/" style={link}>embroidery guides</a>.
      </p>
    </main>
  );
}

const page = {
  maxWidth: "850px",
  margin: "40px auto",
  padding: "24px",
  color: "var(--text-primary, #F5EEDD)",
  lineHeight: 1.8,
  minHeight: "300px",
};

const heading = { color: "var(--text-heading, #F5EEDD)" };

const subheading = {
  color: "var(--text-heading, #F5EEDD)",
  fontSize: 20,
  margin: "28px 0 8px",
};

const list = { paddingLeft: 22, margin: "8px 0" };

const link = { color: "var(--accent-link, #4a90d9)", fontWeight: 600, textDecoration: "none" };
